import React from 'react';
import DivSX, { DivSXProps } from 'tradevan-ui/@emotion/DivSX';
import { classCombine } from 'tradevan-ui/consts';

const Rim = (props: DivSXProps): JSX.Element => {
  const { className, ...other } = props;
  return <DivSX className={classCombine(`rim`, className)} {...other} />;
};

export default Rim;
